import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getUserRole } from "../hooks/getUserRoles";
import { normalizeRole } from "../utils/roles";

const ProtectedRoute = ({
  allowedRoles,
  redirectPath = "/unauthorized",
}: any) => {
  // Normalize BOTH sides so the check works whether the backend returns the
  // old role names (Admin, Project Manager, …) or the new ones (Owner, Manager,
  // Analyst, Contributor, Viewer). This decouples auth from the 7→5 rename.
  const userRole = normalizeRole(getUserRole());
  const allowed: (string | null)[] = (allowedRoles ?? []).map((r: string) =>
    normalizeRole(r),
  );

  if (userRole && allowed.includes(userRole)) {
    return <Outlet />;
  }
  return <Navigate to={redirectPath} replace />;
};

export default ProtectedRoute;
